module.exports = "<app-create-catalog-grouping></app-create-catalog-grouping>"